import React from "react";
var LoaderIconMj = function (props) { return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: props.className },
    React.createElement("g", null,
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
        React.createElement("path", { fill: props.fill, d: "M12 3a9 9 0 0 1 9 9h-2a7 7 0 0 0-7-7V3z" })))); };
export default LoaderIconMj;
